import {
  useGlobalCurrency,
  useSnapshot,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { useNetWorthBreakdown } from "@iliotech/data-wire";
import React from "react";
import { useParams } from "react-router-dom";
import { PieTable } from "src/components/PieTable/PieTable";
import cn from "classnames";
import s from "./NetWorthPieWidget.module.scss";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const NetWorthPieWidget = ({
  isHalfHeight,
  isHalfWidth,
  periodContext,
  structureContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const { grouping, selectedGroup } =
    structureContext || useStructureGrouping();
  const { currencyFormatter } = useGlobalCurrency();
  const periodString = periodContext?.periodString;
  const { data: snapshots } = useSnapshot(portfolioId, periodContext?.period);
  const { pieTableData } = useNetWorthBreakdown(
    snapshots?.data,
    false,
    structureContext
  );
  const openPieTableData = pieTableData.filter(
    (p) => p.value > 0.49 || p.value < -0.49
  );
  const netWorthTitle = React.useMemo(
    () =>
      `Net Worth by ${
        !selectedGroup?.code ? `${grouping.label}` : selectedGroup?.label
      }`,
    [selectedGroup, grouping]
  );
  console.log({ openPieTableData });

  return (
    <div className={cn(s.pieInsightsSurround)}>
      <div className={cn(s.pieSurround)}>
        <h6 className={cn("element-title")}>{netWorthTitle}</h6>
        <p className={"period-string"}>{periodString}</p>
        <PieTable
          isPdf
          isCol={!isHalfHeight}
          isSmall={isHalfWidth && isHalfHeight}
          data={openPieTableData}
          valueFormatter={currencyFormatter}
        />
      </div>
    </div>
  );
};
